import {__core_private__ as _} from '@angular/core';

export var makeDecorator: typeof _.makeDecorator = _.makeDecorator;
export var reflector: typeof _.reflector = _.reflector;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
